import React, { useEffect, useState } from "react";
import { CircleF, GoogleMap, MarkerF } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import { stepsActions } from "../../../../../store/steps-slice";
import MarkerIcon from "../../../../../assets/icons/markerIcon.svg";
import Geocode from "react-geocode";
import { getDetails } from "use-places-autocomplete";

const GoogleMapLocation = () => {
  const dispatch = useDispatch();
  const coords = useSelector((state) => state.steps.coords);
  const autocomplete = useSelector((state) => state.steps.autocomplete);
  const geocoder = useSelector((state) => state.steps.geocoder);

  const [currentPosition, setCurrentPosition] = useState({
    lat: coords ? coords.lat : 13.0826802,
    lng: coords ? coords.lng : 80.2707184,
  });

  const mapRetroStyles = [
    { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{ color: "#c9b2a6" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "geometry.stroke",
      stylers: [{ color: "#dcd2be" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#ae9e90" }],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#93817c" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#a5b076" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#447530" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#f5f1e6" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#fdfcf8" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#f8c967" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#e9bc62" }],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "geometry",
      stylers: [{ color: "#e98d58" }],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "geometry.stroke",
      stylers: [{ color: "#db8555" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#806b63" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "transit.line",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8f7d77" }],
    },
    {
      featureType: "transit.line",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#ebe3cd" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#dfd2ae" }],
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#b9d3c2" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#92998d" }],
    },
  ];

  const mapStyles = {
    height: "400px",
    width: "100%",
    border: "1.5px solid #E9E9E9",
    borderRadius: "15px",
    maxWidth: "100%",
  };

  const onMarkerDragEnd = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    e.domEvent.preventDefault();
    await getCity({ lat, lng });
    dispatch(stepsActions.setCoords({ lat, lng }));
    sessionStorage.setItem("lat", lat);
    sessionStorage.setItem("lng", lng);
    setCurrentPosition({ lat, lng });
  };

  const options = {
    strokeColor: "#FFFFFF",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#0F6EFF",
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 30000,
    zIndex: 1,
  };

  async function getCity(currentPosition) {
    Geocode.setApiKey("AIzaSyB-JybjIwFY88wIlI8aKkVU5E2SltUwDTQ");
    Geocode.setLanguage("en");
    Geocode.fromLatLng(currentPosition.lat, currentPosition.lng).then(
      (response) => {
        dispatch(stepsActions.handleSetAutoComplete(null));
        dispatch(stepsActions.handleSetGeocoder(response));

        const location = response.plus_code.compound_code?.substring(8).trim() ?? response.results[0].formatted_address;
        let city, state, country, locality;
        const id = response.results[0].place_id;
        for (let i = 0; i < response.results[0].address_components.length; i++) {
          for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
            switch (response.results[0].address_components[i].types[j]) {
              case "sublocality_level_2":
              case "sublocality_level_1":
              case "neighborhood":
                if (!locality) locality = response.results[0].address_components[i].long_name;
              case "locality":
                city = response.results[0].address_components[i].long_name;
                break;
              case "administrative_area_level_1":
                state = response.results[0].address_components[i].long_name;
                break;
              case "country":
                country = response.results[0].address_components[i].long_name;
                break;
            }
          }
        }

        dispatch(stepsActions.setLocation({ city, state, country, location, locality: locality ?? city, id }));
        dispatch(stepsActions.handleSearchLocationInput(true));
      },
      (error) => {
        console.error(error);
      }
    );
  }

  function initializeFromGeocoder(response) {
    dispatch(stepsActions.handleSetAutoComplete(null));
    dispatch(stepsActions.handleSetGeocoder(response));

    const location = response.plus_code.compound_code?.substring(8).trim() ?? response.results[0].formatted_address;
    let city, state, country, locality;
    const id = response.results[0].place_id;
    for (let i = 0; i < response.results[0].address_components.length; i++) {
      for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
        switch (response.results[0].address_components[i].types[j]) {
          case "sublocality_level_2":
          case "sublocality_level_1":
          case "neighborhood":
            if (!locality) locality = response.results[0].address_components[i].long_name;
          case "sublocality":
          case "locality":
            city = response.results[0].address_components[i].long_name;
            break;
          case "administrative_area_level_1":
            state = response.results[0].address_components[i].long_name;
            break;
          case "country":
            country = response.results[0].address_components[i].long_name;
            break;
        }
      }
    }

    dispatch(stepsActions.setLocation({ city, state, country, location, locality: locality ?? city, id }));
    dispatch(stepsActions.handleSearchLocationInput(true));
  }

  async function initializeFromAutocomplete(response) {
    const id = response?.place_id;
    const locality = response.structured_formatting.main_test ?? response.terms[0].name ?? response.description.split(",")[0].trim();

    const details = await getDetails({ placeId: id });

    let city, state, country;
    for (let i = 0; i < details.address_components.length; i++) {
      for (let j = 0; j < details.address_components[i].types.length; j++) {
        switch (details.address_components[i].types[j]) {
          case "sublocality":
          case "locality":
            city = details.address_components[i].long_name;
            break;
          case "administrative_area_level_1":
            state = details.address_components[i].long_name;
            break;
          case "country":
            country = details.address_components[i].long_name;
            break;
        }
      }
    }

    dispatch(stepsActions.handleSearchLocationInput(true));
    dispatch(stepsActions.setLocation({ location: response.description, locality, id, city, state, country }));
  }

  useEffect(() => {
    if (autocomplete) {
      initializeFromAutocomplete(autocomplete);
    } else if (geocoder) {
      initializeFromGeocoder(geocoder);
    }
  }, [autocomplete, geocoder]);

  useEffect(() => {
    if (coords) {
      setCurrentPosition({ lat: coords.lat, lng: coords.lng });
    }
  }, [coords]);

  return (
    <div className="googleMapLocation">
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={8}
        center={currentPosition}
        options={{ styles: mapRetroStyles, mapTypeControl: false, fullscreenControl: false, zoomControl: false, streetViewControl: false, keyboardShortcuts: false }}
      >
        <MarkerF position={currentPosition} onDragEnd={(e) => onMarkerDragEnd(e)} draggable={true} icon={MarkerIcon} />
        <CircleF center={currentPosition} options={options} />
      </GoogleMap>
    </div>
  );
};

export default GoogleMapLocation;
